module.exports = __webpack_public_path__ + "81269987a1aa2f4eadc6d0b2d13e1540.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/icons/demo-gray.png
// module id = 1729
// module chunks = 0